import cssClasses from "./PaymentStatusModal.module.css";
import CloseIcon from "@mui/icons-material/Close";
import Close from "../../Components/Icons/Close";
import { Box } from "@mui/material";
import Modal from "@mui/material/Modal";
import Datagrid from "../../Subcomponents/Datagrid";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../../Components/Icons/Dot";
import { useSelector } from "react-redux";

export default function PaymentStatusDetailsModal({
  open,
  handleClose,
  data,
  popupType,
}) {
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  function formatNumber(value) {
    if (value >= 10000000) {
      const croreValue = (value / 10000000).toFixed(2);
      return `${croreValue} Cr.`;
    } else {
      const formattedValue = new Intl.NumberFormat("en-IN").format(value);
      return formattedValue;
    }
  }

  function convertId(idString) {
    const year = idString.slice(0, 4);
    const month = idString.slice(4, 6);
    const day = idString.slice(6, 8);
    const sequence = idString.slice(8);

    const formattedId = `VJ${year}${month}${day}-${sequence}`;

    return formattedId;
  }

  const columns = [
    {
      field: "salesPerson",
      headerName: "Sales Person",
      width: 200,
      renderCell: (params) => {
        return (
          <div className={cssClasses.FirstTitle}>{params.row?.salesPerson}</div>
        );
      },
    },
    {
      field: "leadName",
      headerName: "Lead Name",
      width: 350,
      renderCell: (params) => {
        return (
          <div>
            <p> {params.row?.leadName?.personId?.name}</p>
            <p style={{ opacity: "0.7" }}>
              {convertId(params.row?.leadName?.leadDisplayId)}
            </p>
          </div>
        );
      },
    },
    {
      field: "Status",
      headerName: "Status",
      width: 270,
      renderCell: (params) => {
        return (
          <>
            {" "}
            {params.row.Status && (
              <LeadStatusChip
                label={params.row.Status}
                style={
                  params.row.Status.includes("Complete") ||
                  params.row.Status.includes("Processed")
                    ? { color: "#027A48", backgroundColor: "#ECFDF3" }
                    : params.row.Status.includes("Agreement Done")
                    ? { color: "#0f70ea", backgroundColor: "#eef8ff" }
                    : params.row.Status.includes("Partial")
                    ? { color: "#5925dc", backgroundColor: "#f4f3ff" }
                    : { color: "#B54708", backgroundColor: "#FFFAEB" }
                }
                icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
              />
            )}
          </>
        );
      },
    },
    {
      field: "details",
      headerName: "Details",
      width: 650,
      renderCell: (params) => {
        return (
          <>
            {params.row.details ? (
              <div>
                {params.row.details?.wingId?.wingName} |{" "}
                {params.row.details?.unitNo} |{" "}
                {params.row.details?.inventoryTypeId?.type}(
                {params.row.details?.displayUnitType}) |{" "}
                {params.row.details?.projectId?.projectName}
              </div>
            ) : (
              ""
            )}
          </>
        );
      },
    },
    {
      field: "paidAmount",
      headerName: "Paid Amount",
      width: 180,
      renderCell: (params) => {
        const value = params.row?.paidAmount
        const totalPaid = value.paidAmt?.ocr + value.paidAmt?.gst + value.paidAmt?.sdr
        return (
          <div className={cssClasses.FirstTitle}>{
            value.paidAmount !== 0 ? formatNumber(value?.paidAmount)  : value.paidAmt !== null ? formatNumber(totalPaid) : "N/A"
          }
            {/* {params.row?.paidAmount === 0
              ? "NA"
              : formatNumber(params.row?.paidAmount)} */}
          </div>
        );
      },
    },
    {
      field: "allotmentDate",
      headerName: "Allotment Date",
      width: 300,
      renderCell: (params) => {
        return (
          <div className={cssClasses.FirstTitle}>
            {params.row?.allotmentDate}
          </div>
        );
      },
    },
  ];

  const getStatusData = (el, statusType) => {
    const statusMap = {
      Pending: 0,
      Partial: 1,
      Complete: 2,
      "SDR Pending": 3,
      "SDR Complete": 4,
      "OCR & GST Pending": 5,
      "OCR & GST Complete": 6,
    };
    return el?.statusData[statusMap[statusType]]?.[statusType] || [];
  };

  const dateFormate = (timestamp) => {
    if (!timestamp) {
      return "-";
    }

    const currentDate = new Date();
    const date = new Date(timestamp);

    const isToday =
      date.getDate() === currentDate.getDate() &&
      date.getMonth() === currentDate.getMonth() &&
      date.getFullYear() === currentDate.getFullYear();

    if (isToday) {
      const options = {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      };
      return "Today, " + new Intl.DateTimeFormat("en-US", options).format(date);
    } else {
      const options = {
        weekday: "long",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      };
      return new Intl.DateTimeFormat("en-US", options).format(date);
    }
  };

  let paymentData = [];

  const getDetails = (el, type) => {
    const statusType = type !== "Pending" ? type : "Pending";

    paymentData = getStatusData(el, statusType).map((detail, i) => ({
      id: i,
      salesPerson: detail?.leadId?.userId?.name,
      leadName: detail?.leadId,
      Status: detail?.status,
      details: detail?.unitId,
      paidAmount: detail,
      allotmentDate: dateFormate(detail?.created_at),
    }));
    return paymentData;
  };

  getDetails(data, popupType);

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={cssClasses.container}>
          <div className={cssClasses.header} style={{ marginBottom: "2rem" }}>
            <p className={cssClasses.heading}>{popupType} Status</p>
            <Box
              ml={"auto"}
              mt={1}
              onClick={handleClose}
              style={{ cursor: "pointer" }}
            >
              <Close width={"1.2rem"} height={"1.2rem"} />
            </Box>
          </div>
          <div className={cssClasses.gridWrapper}>
            {
              <Datagrid
                hideFooter={false}
                columns={(loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true) ? columns : columns.filter(v => v?.field !== "salesPerson")}
                rows={paymentData}
              />
            }
          </div>
        </div>
      </Modal>
    </>
  );
}
